export default __webpack_public_path__ + "static/62909-e504bfb4aef59063bea570f061cf98d0.jpg";